"use client";

import {
  useTheme,
  useMediaQuery,
  Box,
  Grid,
  Link,
  Typography,
} from "@mui/material";
import { pxToVw } from "@/utils/pxToVw";
import { MOBILE_BASE } from "@/theme/theme";
import AbrirDoofinder from "./AbrirDoofinder";
import React from "react";
import { useText } from "@/context/TextContext";
import { usePathname } from "next/navigation";
import {
  isCatalogoDigitalCestaDeseosOrPresupuestosPath,
  isCatalogoDigitalProductoPath,
} from "@/utils/catalogoDigital";

type BreadcrumbItem = {
  label: string;
  href: string;
};

type Props = {
  breadcrumb: BreadcrumbItem[];
};

export default function HeaderBotiga({ breadcrumb }: Props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const buscar = useText("block.buscar");
  const pathname = usePathname();
  const cartUrl = useText("cart.url");
  const checkoutUrl = useText("checkout.url");

  const hideRightSearch = pathname === cartUrl || pathname === checkoutUrl || isCatalogoDigitalCestaDeseosOrPresupuestosPath(pathname);
  const isCatalogoDigitalProducto = isCatalogoDigitalProductoPath(pathname);

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumb.map((item, index) => {
      const listItem: any = {
        "@type": "ListItem",
        position: index + 1,
        name: item.label,
      };
      if (index < breadcrumb.length - 1) {
        listItem.item = "https://www.casagay.com" + item.href;
      }

      return listItem;
    }),
  };

  const component = (
    <Grid
      container
      borderTop={1}
      borderBottom={1}
      borderColor={"#472600"}
      py={{ xs: pxToVw(13, MOBILE_BASE), md: pxToVw(13) }}
      px={{ xs: pxToVw(15, MOBILE_BASE), md: pxToVw(21) }}
      position={"fixed"}
      width={"100%"}
      bgcolor={"white"}
      zIndex={100}
      className="breadcrumbs"
    >
      <Grid
        container
        size={{ xs: 12, md: 9 }}
        borderTop={1}
        borderColor={"transparent"}
        sx={{
          textTransform: "uppercase",
          fontSize: { xs: pxToVw(12, MOBILE_BASE), md: pxToVw(16) },
        }}
      >
        <Box
          display="flex"
          flexDirection={"row"}
          flexWrap={"wrap"}
          color={isMobile ? "warmaa" : "marron"}
          sx={{
            textTransform: "uppercase",
            fontSize: { xs: pxToVw(12, MOBILE_BASE), md: pxToVw(16) },
          }}
        >

          {breadcrumb.map((item, i) => (
            <React.Fragment key={i}>
              <Link
                variant="caption1"
                href={item.href}
                underline="none"
                color={isMobile ? "warmaa" : "marron"}
                sx={{ textTransform: "uppercase" }}
              >
                <Typography variant="caption1" color="marron">
                  {item.label}
                </Typography>
              </Link>
              {i < breadcrumb.length - 1 && (
                <Box
                  display={"flex"}
                  sx={{
                    mx: { xs: pxToVw(6, MOBILE_BASE), md: pxToVw(6) },
                  }}
                >
                  <Typography variant="caption1" color="marron">
                    /
                  </Typography>
                </Box>
              )}
            </React.Fragment>
          ))}
        </Box>
      </Grid>

      {!isMobile && !hideRightSearch && !isCatalogoDigitalProducto && (
        <Grid
          container
          size={{ xs: 12, md: 3 }}
          justifyContent="flex-end"
          alignContent={"center"}
        >
          <AbrirDoofinder display={"flex"} variant="caption1" color="marron">
            <Box borderBottom={"1px solid #472600"}>{buscar}</Box>
          </AbrirDoofinder>
        </Grid>
      )}
    </Grid>
  );

  return (
    <>
    <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(breadcrumbSchema),
        }}
      />
      {component}
      <Box
        sx={{
          opacity: 0,
          pointerEvents: "none",
          ".breadcrumbs": { position: "static" },
        }}
      >
        {component}
      </Box>
    </>
  );
}
